/* eslint-disable no-unused-expressions */
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { API_TOKEN, API_URL } from "../../Config/secrets";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  websiteLeads: {},
  totalWebsiteLeads: 0,
};

const slice = createSlice({
  name: "websiteLeads",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    stopLoading(state) {
      state.isLoading = false;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    getWebsiteLeadsSuccess(state, action) {
      state.error = null;
      state.totalWebsiteLeads = action.payload.total;
      state.websiteLeads = {
        ...state.websiteLeads,
        [action.payload.page]: action.payload.data,
      };
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

const header = {
  Authorization: API_TOKEN,
};

export function getWebsiteLeads(page = 1, query = '', take = 10, hideLoader = false) {
  return async (dispatch) => {
    try {
      if (!hideLoader) {
        dispatch(slice.actions.startLoading());
      }

      let payload = { skip: page, take };
      if (query) payload.query = query;

      const response = await axios.post(`${API_URL}/website-leads/list`, payload, {
        headers: header,
      });

      if (response?.data?.statusCode === 200) {
        dispatch(
          slice.actions.getWebsiteLeadsSuccess({
            page,
            total: response?.data?.data?.count || 0,
            data: response?.data?.data?.data || [],
          })
        );
        return response?.data;
      }

      dispatch(slice.actions.hasError(response?.data?.message));
      toast.error(response?.data?.message || "Failed to fetch website leads", { autoClose: 3000 });
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message || "Failed to fetch website leads", { autoClose: 3000 });
      dispatch(slice.actions.hasError(error?.response?.data));
      return error?.response?.data;
    }
  };
}

export function deleteWebsiteLeads(ids) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`${API_URL}/website-leads/delete`, { ids }, {
        headers: header,
      });

      if (response?.data?.statusCode === 200) {
        toast.success(response?.data?.message || "Website lead(s) deleted successfully", { autoClose: 3000 });
        return response?.data;
      }

      toast.error(response?.data?.message || "Failed to delete website lead(s)", { autoClose: 3000 });
      dispatch(slice.actions.hasError(response?.data?.message));
      return response?.data;
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message || "Failed to delete website lead(s)", { autoClose: 3000 });
      dispatch(slice.actions.hasError(error?.response?.data));
      return error?.response?.data;
    }
  };
}
